import React from 'react';
// import Card from 'components_v2/common/CardV2/Card';
import TileLayout from 'routes/home/components/mobile/TileLayout';
import PointsTableWrapper from 'routes/newslisting/components/common/PointsTableWrapper';

function FIFAWidget({ data, headerHeading, currentTab }) {
  if (currentTab && currentTab === 'Videos') {
    return <TileLayout lazyload sectionData={data} isFifaWidget />;
  }
  return (
    <PointsTableWrapper
      FifaData={data?.standings}
      isFifaPage
      ifFifaHomePageWidget
      headerHeading={headerHeading}
      currentTab={currentTab}
    />
  );
}

export default FIFAWidget;
